// src/pages/taxonomy/Materials/MaterialsFormPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { MaterialsAPI } from '../../../api/v3/taxonomy-api-v3';

const BASE = '/app/sales/bagspa/taxonomy';

export default function MaterialsFormPage() {
  const { id } = useParams();
  const history = useHistory();
  const isEdit = Boolean(id);

  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    async function load() {
      if (!isEdit) return;
      try {
        setLoading(true);
        const payload = await MaterialsAPI.show(id);
        const item = payload?.item ?? payload?.data ?? payload ?? {};
        setName(item?.name || '');
        setCode(item?.code || '');
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [id, isEdit]);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = { name, code };
      if (isEdit) {
        await MaterialsAPI.update(id, payload);
      } else {
        await MaterialsAPI.create(payload);
      }
      history.push(`${BASE}/materials`);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">{isEdit ? 'Edit' : 'New'} Material</h3>
        <Link to={`${BASE}/materials`}>&larr; Back</Link>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Material name</label>
          <input
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Unique name"
            required
          />
        </div>

        <div className="form-group">
          <label>Material code</label>
          <input
            className="form-control"
            value={code}
            onChange={e => setCode(e.target.value)}
            placeholder="e.g. LE, CA, NY"
            required
          />
        </div>

        <button className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving…' : 'Save'}
        </button>
      </form>
    </div>
  );
}
